<template lang="pug">
	//- Пустой чат: примеры задач для агента
	.ai-chat-empty
		i.fa.fa-magic
		span Ask AI agent to help with your creative:
		ul.ai-chat-empty-hints
			li(v-for="hint in hints" :key="hint") {{hint}}
</template>

<script>
	// Примеры задач для агента, показываемые в пустом чате
	const EMPTY_CHAT_HINTS = [
		'Change settings',
		'Add or change tracking events',
		'Generate images (sprites with a transparent background or backgrounds)',
		'Drop files here or attach them with the paperclip button (images, videos, fonts, sounds, 3D models, JSON, zip and html, up to 25 MB) to import them as assets',
		'Edit texts and translate to other languages',
		//'Add animations and sounds',
		'Fix a bug or explain how the creative works',
		'Create a new version or a variation'
	];

	export default {
		name: "AIAgentEmptyChat",
		data() {

			this.hints = EMPTY_CHAT_HINTS;

			return {};

		}
	}
</script>

<style lang="sass">

	.ai-chat
		.ai-chat-history
			.ai-chat-empty
				display: flex
				flex-direction: column
				align-items: center
				justify-content: center
				gap: 8px
				text-align: center
				height: 100%
				color: #73818f
				font-size: 13px
				user-select: none

				.ai-chat-empty-hints
					list-style: none
					margin: 0
					padding: 0
					font-size: 12px
					line-height: 18px
					color: #5f6b77

</style>
